
import { Task } from '@/types/lead';
import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';
import { format } from 'date-fns';
import { stripHtml } from '@/utils/htmlUtils';

interface CompletedTasksListProps {
  tasks: Task[];
  onDeleteTask: (taskId: string) => void;
  getTaskStatusIndicator: (status: any, dueDate?: Date | string) => React.ReactNode;
}

const CompletedTasksList = ({
  tasks,
  onDeleteTask,
  getTaskStatusIndicator
}: CompletedTasksListProps) => {
  const visibleTasks = tasks.slice(0, 3);
  const hasMoreTasks = tasks.length > 3;

  return (
    <div>
      <h4 className="font-medium text-sm mb-3">Completed Tasks ({tasks.length})</h4>
      <div className="space-y-4">
        {visibleTasks.map((task) => (
          <div key={task.id} className="border rounded-lg p-4 bg-muted/50">
            <div className="flex items-start justify-between">
              <div>
                <h4 className="font-medium line-through text-muted-foreground">
                  {task.title}
                </h4>
                {task.description && (
                  <p className="text-sm text-muted-foreground mt-1 line-through">
                    {stripHtml(task.description)}
                  </p>
                )}
                <div className="flex flex-wrap gap-2 mt-2">
                  {getTaskStatusIndicator(task.status)}
                  {task.completedAt && (
                    <span className="text-xs text-muted-foreground">
                      Completed on {format(new Date(task.completedAt), 'MMM d, yyyy')}
                    </span>
                  )}
                </div>
              </div>
              <Button
                variant="outline"
                size="icon"
                onClick={() => onDeleteTask(task.id)}
                title="Delete task"
              >
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          </div>
        ))}

        {hasMoreTasks && (
          <Button variant="ghost" className="w-full" onClick={() => {}}>
            Show {tasks.length - 3} more completed tasks
          </Button>
        )}
      </div>
    </div>
  );
};

export default CompletedTasksList;
